import React from 'react'

export const WalletSymbol = ({
  className,
  size,
}: {
  className?: string
  size: number
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.77 2.93652L14.735 3.01819L11.3516 10.8699H8.02662C7.23329 10.8699 6.47495 11.0332 5.78662 11.3249L7.82829 6.44819L7.87495 6.33152L7.95662 6.14486C7.97995 6.07486 8.00329 6.00486 8.03829 5.94652C9.56662 2.41152 11.2933 1.60652 14.77 2.93652Z'
        stroke='currentColor'
        stroke-width='2.19645'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M21.0587 11.1081C20.5337 10.9447 19.9737 10.8747 19.4137 10.8747H11.3521L14.7354 3.02307L14.7704 2.94141C14.9454 2.99974 15.1087 3.08141 15.2837 3.15141L17.8621 4.23641C19.2971 4.83141 20.3004 5.44974 20.907 6.19641C21.0237 6.33641 21.117 6.46474 21.1987 6.61641C21.3037 6.77974 21.3854 6.94307 21.4321 7.11807C21.4787 7.22307 21.5137 7.32807 21.5371 7.42141C21.8521 8.40141 21.6654 9.60307 21.0587 11.1081Z'
        stroke='currentColor'
        stroke-width='2.19645'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M25.1088 16.5683V18.8433C25.1088 19.0767 25.0972 19.31 25.0855 19.5433C24.8638 23.615 22.5888 25.6683 18.2722 25.6683H9.17217C8.89217 25.6683 8.61217 25.645 8.34383 25.61C4.63383 25.365 2.6505 23.3817 2.4055 19.6717C2.3705 19.4033 2.34717 19.1233 2.34717 18.8433V16.5683C2.34717 14.2233 3.7705 12.205 5.8005 11.33C6.5005 11.0383 7.24717 10.875 8.0405 10.875H19.4272C19.9988 10.875 20.5588 10.9567 21.0722 11.1083C23.3938 11.82 25.1088 13.99 25.1088 16.5683Z'
        stroke='currentColor'
        stroke-width='2.19645'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M7.82801 6.45312L5.78634 11.3298C3.75634 12.2048 2.33301 14.2231 2.33301 16.5681V13.1498C2.33301 9.83646 4.68967 7.07146 7.82801 6.45312Z'
        stroke='currentColor'
        stroke-width='2.19645'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M25.1055 13.1489V16.5672C25.1055 14.0005 23.4022 11.8189 21.0688 11.1189C21.6755 9.60219 21.8505 8.41219 21.5588 7.42052C21.5355 7.31552 21.5005 7.21052 21.4538 7.11719C23.6238 8.23719 25.1055 10.5355 25.1055 13.1489Z'
        stroke='currentColor'
        stroke-width='2.19645'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  )
}
